export function formatCurrency(money) {
	return typeof money === 'number'
		? money.toLocaleString(undefined, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		})
		: '';
}